import { Comparison } from "../../../../features/Comparison";
import { ComparisonPage } from "../../../../pages/ComparisonPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const comparisonPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.llm_compare.root,
  element: <ComparisonPage />,
  name: "Сравнение LLM моделей",
  children: appRouterPaths.llm_compare.item
    ? [
        {
          path: appRouterPaths.llm_compare.item,
          element: <Comparison />,
          name: "Объекты сравнения",
        },
      ]
    : undefined,
};
